import { CSSProperties } from 'react';
import { CloseSVG } from 'rwl-ui';
import styled from 'styled-components6';

const StyledCloseButton = styled.div`
    cursor: pointer;
    display: flex;
    color: var(--rwl-palette-gray-500);
    height: 32px;
    width: 32px;
    align-items: center;
    justify-content: center;
    border-radius: var(--rwl-radius-lg);
    &:hover {
        background-color: var(--rwl-background-level1);
    }
`;

export const CloseButton = ({
    onClick,
    styles,
}: {
    onClick?: () => void;
    styles?: CSSProperties;
}) => {
    return (
        <StyledCloseButton style={{ ...styles }} onClick={onClick}>
            <CloseSVG />
        </StyledCloseButton>
    );
};
